/**
 * DashboardLayoutContext — Canonical layout context for all app shells.
 * Single source of truth: packages/ui
 *
 * Exposes:
 *  - rightPanel mode (none | filters | search | account)
 *  - setRightPanel setter
 *  - optional sidebarOpen flag
 */
import { createContext, useContext } from 'react';
import type { RightPanelMode } from './DesktopRightPanel';

export interface DashboardLayoutContextValue {
  /** Whether the mobile sidebar is currently open */
  sidebarOpen?: boolean;
  /** Current desktop right panel mode */
  rightPanel: RightPanelMode;
  /** Open or close the desktop right panel */
  setRightPanel: (panel: RightPanelMode) => void;
}

const DashboardLayoutContext = createContext<DashboardLayoutContextValue | null>(null);

/** Wrap your app shell with this provider */
export const DashboardLayoutProvider = DashboardLayoutContext.Provider;

/**
 * Hook to access dashboard layout state.
 * Returns null if not within a DashboardLayout shell.
 */
export function useDashboardLayout(): DashboardLayoutContextValue | null {
  return useContext(DashboardLayoutContext);
}
